module.exports = "<router-outlet #o=\"outlet\"></router-outlet>\n<app-loader></app-loader>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/auth/auth.component.html
// module id = ../../../../../src/app/auth/auth.component.html
// module chunks = main